import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListParams } from "../types/common";
import { SaveVisionMissionPayload } from "../types/visionMissionType";

export const getVisionMissionList = createAsyncThunk("/visionMission/list", async (params: ListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  const response = (await api.get(`/visionmission?${query.toString()}`)).data;
  return response;
});

export const saveVisionMission = createAsyncThunk("/visionMission/save", async (payload: SaveVisionMissionPayload) => {
  const response = (await api.post("/visionmission/action", payload)).data;
  return response;
});

export const deleteVisionMission = createAsyncThunk("/visionMission/delete", async (id: number) => {
  const response = (await api.get(`/visionmission/delete/${id}`)).data;
  return response;
});
